<div class="top-nav-row">
  <div class="links">
    @for (link of links; track link.path) {
      <a
        mat-button
        [routerLink]="link.path"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: link.exact === true }"
        >{{ link.label }}</a
      >
    }
  </div>

  <div class="user-actions">
    @if (!authResolved) {
      <span class="auth-loading">Checking session...</span>
    } @else if (!isAuthenticated) {
      <a class="signin-wide" mat-button routerLink="/login">Login</a>
      <a class="signin-compact" mat-stroked-button color="primary" routerLink="/login">Sign in</a>
    } @else {
      <button
        mat-icon-button
        aria-label="User menu"
        [matMenuTriggerFor]="userMenu"
        class="user-menu-trigger"
      >
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item routerLink="/profile">
          <mat-icon>person</mat-icon>
          <span>Profile</span>
        </button>
        <button mat-menu-item routerLink="/history">
          <mat-icon>history</mat-icon>
          <span>History</span>
        </button>
        @if (isAdmin) {
        <button mat-menu-item routerLink="/admin">
          <mat-icon>admin_panel_settings</mat-icon>
          <span>Admin</span>
        </button>
        }
        <button mat-menu-item (click)="logout.emit()">
          <mat-icon>logout</mat-icon>
          <span>Sign Out</span>
        </button>
      </mat-menu>
    }
  </div>
</div>
